module.exports = __webpack_public_path__ + "media/images/service/s_5-bfdad0c951dfd9f862dec1773b26a874.png";